// src/components/PropertyCard.js
import { Link } from "react-router-dom";
import Badges from "./Badges";

const fmt = (n) => {
  if (n >= 10000000) return `₹${(n / 10000000).toFixed(1)} Cr`;
  if (n >= 100000) return `₹${(n / 100000).toFixed(1)} Lakh`;
  if (n >= 1000) return `₹${(n / 1000).toFixed(0)}K`;
  return `₹${n}`;
};

export default function PropertyCard({ property: p }) {
  const img = p.images?.[0] || "https://images.unsplash.com/photo-1570129477492-45c003edd2be?w=600&q=80";

  return (
    <Link to={`/property/${p.id}`} style={{ textDecoration: "none" }}>
      <div style={{
        background: "white", borderRadius: 14, overflow: "hidden",
        border: `1px solid ${p.urgent ? "#f5c6c6" : "#e2ece2"}`,
        boxShadow: p.urgent ? "0 0 0 1.5px #c0392b22" : "0 2px 8px rgba(0,0,0,0.05)",
        transition: "transform 0.18s, box-shadow 0.18s",
        cursor: "pointer",
      }}
        onMouseEnter={e => { e.currentTarget.style.transform = "translateY(-4px)"; e.currentTarget.style.boxShadow = "0 14px 32px rgba(26,107,60,0.12)"; }}
        onMouseLeave={e => { e.currentTarget.style.transform = "translateY(0)"; e.currentTarget.style.boxShadow = p.urgent ? "0 0 0 1.5px #c0392b22" : "0 2px 8px rgba(0,0,0,0.05)"; }}
      >
        {/* Image */}
        <div style={{ position: "relative" }}>
          <img src={img} alt={p.title} style={{ width: "100%", height: 180, objectFit: "cover", display: "block" }} loading="lazy" />
          <div style={{ position: "absolute", top: 10, left: 10, display: "flex", gap: 4 }}>
            <span style={{ background: "#1a6b3c", color: "white", fontSize: 11, fontWeight: 700, padding: "3px 9px", borderRadius: 20 }}>{p.type}</span>
            {p.urgent && <span style={{ background: "#c0392b", color: "white", fontSize: 10, fontWeight: 700, padding: "3px 8px", borderRadius: 20 }}>🔥 Urgent</span>}
          </div>
          {p.verified && (
            <div style={{ position: "absolute", top: 10, right: 10 }}>
              <span style={{ background: "#e8f5e9", color: "#1a6b3c", fontSize: 10, fontWeight: 700, padding: "3px 8px", borderRadius: 20 }}>✓ Verified</span>
            </div>
          )}
          {/* Multiple images indicator */}
          {p.images?.length > 1 && (
            <div style={{ position: "absolute", bottom: 8, right: 8, background: "rgba(0,0,0,0.55)", color: "white", fontSize: 11, padding: "2px 7px", borderRadius: 10 }}>
              📷 {p.images.length}
            </div>
          )}
        </div>

        {/* Content */}
        <div style={{ padding: "14px 15px" }}>
          <p style={{ fontWeight: 700, fontSize: 14, color: "#1a2e1a", marginBottom: 2, lineHeight: 1.35, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{p.title}</p>
          <p style={{ fontSize: 21, fontWeight: 800, color: "#1a6b3c", fontFamily: "'Sora', sans-serif", marginBottom: 5 }}>
            {fmt(p.price)}{p.listingType === "Rent" ? <span style={{ fontSize: 13, fontWeight: 500 }}>/mo</span> : ""}
          </p>
          <div style={{ display: "flex", alignItems: "center", gap: 4, marginBottom: 8 }}>
            <span style={{ fontSize: 13 }}>📍</span>
            <span style={{ fontSize: 13, color: "#6b7c6b" }}>{p.location}, Satna</span>
          </div>
          <div style={{ display: "flex", gap: 10, fontSize: 12, color: "#6b7c6b", marginBottom: 10 }}>
            {p.area && <span>📐 {p.area} sq.ft</span>}
            {p.bedrooms && <span>🛏 {p.bedrooms} BHK</span>}
            {p.bathrooms && <span>🚿 {p.bathrooms} Bath</span>}
          </div>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <Badges property={p} />
            <span style={{ fontSize: 11, color: "#6b7c6b" }}>{p.ownerOnly ? "No Broker" : ""}</span>
          </div>
        </div>
      </div>
    </Link>
  );
}
